module.exports = __webpack_public_path__ + "static/media/teeth-open.ad2db883.svg";